import { render, staticRenderFns } from "./historialIngresos.vue?vue&type=template&id=0ca129cb&scoped=true&"
import script from "./historialIngresos.vue?vue&type=script&lang=js&"
export * from "./historialIngresos.vue?vue&type=script&lang=js&"
import style0 from "./historialIngresos.vue?vue&type=style&index=0&id=0ca129cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca129cb",
  null
  
)

export default component.exports